import useLocalStorage from "../../hooks/useLocalStorage/index.js";
export const useKeyValueHook = (appName, authUniqueId, key, defaultValue) => useLocalStorage(`${appName}${authUniqueId}${key}`, defaultValue);
export default useKeyValueHook;
